import { getUserTokens } from '@/api/query/customer';
import { useState, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';

export const useUserTokens = (enabled = false) => {
	const [tokenCount, setTokenCount] = useState(0);

	const getUserTokensMutation = useMutation({
		mutationFn: () => getUserTokens(),
		onSuccess: ({ data }) => {
			setTokenCount(() => data);
		},
	});

	const handleGetTokens = () => {
		if (!enabled) {
			return;
		}
		getUserTokensMutation.mutate();
	};

	useEffect(() => {
		if (!enabled) {
			setTokenCount(0);
			return;
		}

		handleGetTokens();
	}, [enabled]);

	return {
		tokenCount,
		isLoading: getUserTokensMutation.isPending,
		handleGetTokens,
	};
};
